import {Component} from 'react'

import TabItem from './components/TabItem'
import ProjectItem from './components/ProjectItem'
import Header from './components/Header'

import './App.css'

const tabsList = [
  {tabId: 'STATIC', displayText: 'Static'},
  {tabId: 'RESPONSIVE', displayText: 'Responsive'},
  {tabId: 'DYNAMIC', displayText: 'Dynamic'},
  {tabId: 'React JS', displayText: 'React JS'},
]

const projectsList = [
  {
    projectId: 1,
    category: 'STATIC',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/projects-s3-img.png',
    title: 'Music Page',
    description:
      'The music page enables the users to browse through the images of all-time favorite music albums.',
    link: '',
  },
  {
    projectId: 2,
    category: 'STATIC',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/projects-s4-img.png',
    title: 'Tourism Website',
    description:
      'A tourism website enables the user to browse through the images of popular destinations.',
    link: '',
  },
  {
    projectId: 3,
    category: 'STATIC',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/projects-s1-img.png',
    title: 'Advanced Technologies',
    description:
      'A website that gives you a basic understanding of Advanced Technologies.',
    link: '',
  },
  {
    projectId: 4,
    category: 'RESPONSIVE',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/projects-r4-img.png',
    title: 'VR Website',
    description:
      'VR Website enables users to explore AR and VR Products and Industry happenings.',
    link: '',
  },
  {
    projectId: 5,
    category: 'RESPONSIVE',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/projects-r2-img.png',
    title: 'Food Munch',
    description: 'Food Much Website is a user-centric food tech website.',
    link: 'https://vsnfoodmunchapp.ccbp.tech',
  },
  {
    projectId: 6,
    category: 'RESPONSIVE',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/projects-r3-img.png',
    title: 'Portfolio',
    description:
      'A portfolio is the best alternative for a resume to showcase your skills to the digital world.',
    link: 'https://portfolioofnvs.ccbp.tech',
  },

  {
    projectId: 7,
    category: 'DYNAMIC',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/projects-d3-img.png',
    title: 'Speed Typing Test',
    description:
      'Speed Typing Test Application is capable of calculating the time to type the randomly generated quote.',
    link: 'https://typingspeedexam.ccbp.tech',
  },
  {
    projectId: 8,
    category: 'DYNAMIC',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/projects-d1-img.png',
    title: 'Random Joke Page',
    description:
      'Random Joke Page is an API-based dynamic Web Application that generates a new joke.',
    link: 'https://randomjokebynvs.ccbp.tech',
  },
  {
    projectId: 9,
    category: 'DYNAMIC',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/projects-d2-img.png',
    title: 'Sizing An Image',
    description:
      'This is a dynamic web application capable of adjusting the size of an element using DOM manipulations.',
    link: 'https://sizingapic.ccbp.tech',
  },
  {
    projectId: 10,
    category: 'React JS',
    imageURL: 'https://assets.ccbp.in/frontend/react-js/speedometer-img.png',
    title: 'Speedo Meter for games',
    description:
      'Its a simple web page useful in online games,displaying speedo meeter.Two options of accelerator and brakes provided',
    link: 'https://speedometernvs.ccbp.tech/',
  },
  {
    projectId: 11,
    category: 'React JS',
    imageURL:
      'https://res.cloudinary.com/dbqgguers/image/upload/v1684057854/searchableuserslist_yjc24c.jpg',
    title: 'Searchable users list',
    description:
      'List of users displayed with an option to search and option to delete',
    link: 'https://susersbynvs.ccbp.tech/',
  },
  {
    projectId: 12,
    category: 'React JS',
    imageURL:
      'https://res.cloudinary.com/dbqgguers/image/upload/v1684057328/destinationsearch_vfnmg6.jpg',
    title: 'Destination Search',
    description:
      'Destination Search is a web page where users can search for particular destination',
    link: 'https://tripsearchbynvs.ccbp.tech/',
  },
]

class App extends Component {
  state = {activeTab: tabsList[2].tabId}

  onTabChange = tabId => {
    this.setState({activeTab: tabId})
  }

  render() {
    const {activeTab} = this.state
    const filteredProjects = projectsList.filter(
      eachProject => eachProject.category === activeTab,
    )
    return (
      <div className="app-container">
        <Header />
        <div className="profile-cont">
          <div className="profile-prop">
            <h1 className="title">Hey, I am Venkata Siva Neeli</h1>

            <p className="para-prop description">
              {' '}
              I am currently seeking employment as a Full Stack Developer, with
              expertise in both Frontend and Backend development. Throughout my
              professional journey, I have gained valuable hands-on experience
              working with the following technologies:
            </p>
            <ul className="description">
              <li>HTML</li>
              <li>CSS</li>
              <li>Java Script</li>
              <li>React JS</li>
              <li>Node JS</li>
              <li>Express JS</li>
              <li>SQL</li>
              <li>Python</li>
              <li>Data Science</li>
            </ul>
            <br />
          </div>
        </div>
        <h1 className="title">Projects</h1>
        <p className="description">
          Over the past nine months, I have actively engaged in hands-on
          learning by constructing numerous web pages utilizing a range of
          technologies, including HTML, CSS, Bootstrap, JavaScript, and React. I
          owe a debt of gratitude to NxtWave for their invaluable support
          throughout this journey. Here are a few examples of the web pages I
          have built during this time:
        </p>

        <ul className="tabs-container">
          {tabsList.map(tabDetails => (
            <TabItem
              onTabChange={this.onTabChange}
              key={tabDetails.tabId}
              tabDetails={tabDetails}
              isActive={activeTab === tabDetails.tabId}
            />
          ))}
        </ul>

        <ul className="project-list-container">
          {filteredProjects.map(projectDetails => (
            <ProjectItem
              key={projectDetails.projectId}
              projectDetails={projectDetails}
            />
          ))}
        </ul>

        <div className="footer-cont-prop">
          <div className="footer-ind-cont">
            <h1 className="footer-ind-cont-title-prop">Contact Details</h1>
            <div className="other-details-prop">
              <p>Mobile No: 9xxxxxxxxx</p>
              <p>e-Mail id: sxxxxxxxx@gmail.com</p>
              <p>Address: Kurnool,Andhrapradesh</p>
            </div>
          </div>
          <div className="footer-ind-cont">
            <h1 className="footer-ind-cont-title-prop">Other Details: </h1>
            <div className="other-details-prop">
              <p>Notice Period: Immediate Joiner</p>
              <p>Preferred Locations:Hyderabad, Bangalore</p>
              <p>Willing to learn New Technologies:Yes</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default App
